@if (installationId()) {
  <div class="graphiques-page">
    @if (chargement()) {
      <p class="graphiques-chargement">Chargement des graphiques…</p>
    } @else if (erreur()) {
      <p class="graphiques-erreur">{{ erreur() }}</p>
    } @else if (graphes()?.length) {
      <div class="graphiques-liste">
        @for (graphe of graphes()!; track graphe.id) {
          <app-graphe-card [graphe]="graphe" [installationId]="installationId()!" />
        }
      </div>
    } @else if (graphes() !== null) {
      <div class="page-vide">
        <span class="material-symbols-outlined page-vide-icone">bar_chart</span>
        <p>Aucun graphique n'est configuré pour cette installation.</p>
      </div>
    }
  </div>
} @else {
  <div class="page-vide">
    <span class="material-symbols-outlined page-vide-icone">bar_chart</span>
    <p>Sélectionnez une installation dans le panneau de gauche pour afficher ses graphiques.</p>
  </div>
}
